var _excluded = ["name", "type", "onClick", "onKeyDown", "onMouseEnter", "isActive"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React, { useContext } from "react";
import styled, { css } from "styled-components";
import OnColorContext from "../../../../../../contexts/OnColorContext";
import useBreakpoint from "../../../../../../hooks/useBreakpoint";
var Building1 = function Building1(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M15 16H1a.973.973 0 0 1-.719-.281A.973.973 0 0 1 0 15V1C0 .708.094.469.281.281A.973.973 0 0 1 1 0h10c.292 0 .531.094.719.281A.973.973 0 0 1 12 1v4h3c.292 0 .531.094.719.281A.973.973 0 0 1 16 6v9a.973.973 0 0 1-.281.719A.973.973 0 0 1 15 16Zm-3-2h2V7h-2v7Zm-3 0h1V2H2v12h1v-3c0-.292.094-.531.281-.719A.973.973 0 0 1 4 10h4c.292 0 .531.094.719.281A.973.973 0 0 1 9 11v3Zm-4 0h2v-2H5v2Zm2-6H5a.973.973 0 0 1-.719-.281A.973.973 0 0 1 4 7c0-.292.094-.531.281-.719A.973.973 0 0 1 5 6h2c.292 0 .531.094.719.281A.973.973 0 0 1 8 7a.973.973 0 0 1-.281.719A.973.973 0 0 1 7 8Zm0-3H5a.973.973 0 0 1-.719-.281A.973.973 0 0 1 4 4c0-.292.094-.531.281-.719A.973.973 0 0 1 5 3h2c.292 0 .531.094.719.281A.973.973 0 0 1 8 4a.973.973 0 0 1-.281.719A.973.973 0 0 1 7 5Z"
  }));
};
Building1.defaultProps = {
  width: "16",
  height: "16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var User = function User(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M8 8c1.7 0 3-1.3 3-3V3c0-1.7-1.3-3-3-3S5 1.3 5 3v2c0 1.7 1.3 3 3 3ZM7 3c0-.6.4-1 1-1s1 .4 1 1v2c0 .6-.4 1-1 1s-1-.4-1-1V3Zm4 7H5c-1.7 0-3 1.3-3 3v2c0 .6.4 1 1 1s1-.4 1-1v-2c0-.6.4-1 1-1h6c.6 0 1 .4 1 1v2c0 .6.4 1 1 1s1-.4 1-1v-2c0-1.7-1.3-3-3-3Z"
  }));
};
User.defaultProps = {
  width: "16",
  height: "16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
import getColor from "../../../../../../utils/getColor";
import getIconColor from "../../../../../../utils/getIconColor";
import getTextColor from "../../../../../../utils/getTextColor";
import space from "../../../../../../utils/space";
import transition from "../../../../../../utils/transition";
import IconAtm from "../../../../../atoms/IconAtm";
import { cssTextAtm } from "../../../../../atoms/TextAtm/TextAtm.styled";
var ArrowSvg = function ArrowSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M5.03.001c.806 0 1.258 1.025.762 1.725L3.762 4.6a.91.91 0 0 1-1.524 0L.207 1.725C-.3 1.025.163 0 .97 0l4.06.001z"
  }));
};
ArrowSvg.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "6",
  height: "5"
};
var typeIcon = {
  person: User,
  company: Building1
};
var emphasisValue = "medium";
var emphasisActiveValue = "high";
var iconBaseStyles = function iconBaseStyles() {
  return css(["", ";flex-shrink:0;"], transition("fill"));
};
var Icon = styled(IconAtm).withConfig({
  componentId: "sc-1wi89td-0"
})(["", ";margin-right:", ";"], iconBaseStyles(), space(1));
var Name = styled.p.withConfig({
  componentId: "sc-1wi89td-1"
})(function (_ref) {
  var $onColor = _ref.$onColor;
  return css(["", ";", ";margin-right:", ";overflow:hidden;text-overflow:ellipsis;white-space:nowrap;"], transition("color"), cssTextAtm({
    typography: "tiny1",
    onColor: $onColor,
    emphasis: emphasisValue
  }), space(1));
});
var Arrow = styled(ArrowSvg).withConfig({
  componentId: "sc-1wi89td-2"
})(function (_ref2) {
  var $onColor = _ref2.$onColor,
    theme = _ref2.theme;
  return css(["", ";fill:", ";"], iconBaseStyles(), getIconColor(theme, $onColor, emphasisValue));
});
var Wrapper = styled.button.withConfig({
  componentId: "sc-1wi89td-3"
})(function (_ref3) {
  var $isActive = _ref3.$isActive,
    $onColor = _ref3.$onColor,
    theme = _ref3.theme;
  return css(["display:inline-flex;align-items:center;padding:0;border:0;background:none;cursor:pointer;&:hover{", ",", "{fill:", ";}", "{color:", ";}}", ""], Icon, Arrow, getIconColor(theme, $onColor, emphasisValue, "hover"), Name, getTextColor(theme, $onColor, emphasisValue, "hover"), $isActive && css(["", "{fill:", ";}", "{color:", ";}", "{fill:", ";}"], Icon, getIconColor(theme, $onColor, emphasisActiveValue), Name, getTextColor(theme, $onColor, emphasisActiveValue), Arrow, getColor(theme, "primary")));
});
function AccountButtonMol(_ref4) {
  var name = _ref4.name,
    type = _ref4.type,
    onClick = _ref4.onClick,
    onKeyDown = _ref4.onKeyDown,
    onMouseEnter = _ref4.onMouseEnter,
    isActive = _ref4.isActive,
    restProps = _objectWithoutProperties(_ref4, _excluded);
  var onColor = useContext(OnColorContext);
  var isSmallOnly = useBreakpoint("small", "medium");
  return /*#__PURE__*/React.createElement(Wrapper, _extends({
    onClick: onClick,
    onKeyDown: onKeyDown,
    onMouseEnter: onMouseEnter,
    $isActive: !!isActive,
    $onColor: onColor
  }, restProps), /*#__PURE__*/React.createElement(Icon, {
    icon: typeIcon[type],
    sizeSpace: 2,
    emphasis: emphasisValue
  }), !isSmallOnly && /*#__PURE__*/React.createElement(Name, {
    $onColor: onColor
  }, name), /*#__PURE__*/React.createElement(Arrow, {
    $onColor: onColor
  }));
}
export default AccountButtonMol;